import { motion } from 'framer-motion'
import {
    MagnifyingGlassIcon,
    ChatBubbleLeftRightIcon,
    AcademicCapIcon,
    ArrowRightIcon,
    SparklesIcon
} from '@heroicons/react/24/outline'

const ProcessSection = () => {
    const steps = [
        {
            title: "Discover Courses",
            description: "Explore our wide range of UGC-recognized online and distance learning programs from top universities.",
            icon: MagnifyingGlassIcon,
            color: "bg-blue-50 text-blue-600 border-blue-100"
        },
        {
            title: "Free Counseling",
            description: "Speak with our expert counselors to find the best course that matches your career goals and aspirations.",
            icon: ChatBubbleLeftRightIcon,
            color: "bg-accent-50 text-accent-600 border-accent-100"
        },
        {
            title: "Direct Enrollment",
            description: "Get assistance with documentation and seamless enrollment into your chosen university.",
            icon: AcademicCapIcon,
            color: "bg-primary-50 text-primary-600 border-primary-100"
        }
    ]

    return (
        <section className="py-24 bg-white relative overflow-hidden">
            <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-20">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="inline-flex items-center space-x-2 bg-primary-50 px-4 py-1.5 rounded-full mb-6 border border-primary-100">
                            <SparklesIcon className="w-5 h-5 text-primary-600" />
                            <span className="text-sm font-bold text-primary-700 uppercase tracking-wider">Our Process</span>
                        </div>
                        <h2 className="text-4xl sm:text-5xl font-black text-gray-900 mb-6 leading-tight tracking-tight">
                            Your Journey to <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Success</span>
                        </h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto font-medium leading-relaxed">
                            Three simple steps to start your educational transformation with MyMargdarshak.
                        </p>
                    </motion.div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
                    {/* Connection Line */}
                    <div className="hidden md:block absolute top-[25%] left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-blue-100 via-accent-100 to-primary-100 -z-0"></div>
                    
                    {steps.map((step, idx) => {
                        const Icon = step.icon
                        return (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: idx * 0.2 }}
                                className="relative z-10 text-center group"
                            >
                                <div className={`w-24 h-24 rounded-[2rem] ${step.color} border flex items-center justify-center mx-auto mb-8 shadow-sm group-hover:shadow-xl group-hover:-translate-y-2 transition-all duration-500`}>
                                    <Icon className="w-10 h-10" />
                                </div>
                                <h3 className="text-2xl font-black text-gray-900 mb-4">{step.title}</h3>
                                <p className="text-gray-500 font-medium leading-relaxed">{step.description}</p>
                                
                                {idx < 2 && (
                                    <div className="md:hidden flex justify-center mt-8 text-gray-200">
                                        <ArrowRightIcon className="w-8 h-8 rotate-90" />
                                    </div>
                                )}
                            </motion.div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default ProcessSection
